//#region Import
import React, { Component } from 'react';
/* React Router */
import { withRouter } from 'react-router-dom'

/* Redux */
import { connect } from 'react-redux'

/* Template */
import TenantNav from '../../template/nav/tenant-apps-nav';
import Footer from "../../lib/components/footer/Footer";

/* Routes */
import { TenantAppsRoutes, RedirectToLogin, domainIsTenant as dit } from '../../routes/routes'

/* Credentials Token */
import { removeTokenDit } from '../../auth/token'

import './app.scss';
//#endregion

class Main extends Component {
  constructor(props) {
    super(props);
    let open = true;
    let navMini = false;
    if (window.innerWidth <= 5000) {
      open = false;
      navMini = true;
    }
    this.state = {
      logout: false,
      navMini,
      open
    }
  }

  toggleNav = (e) => {
    const _this = this
    const _state = _this.state
    let navMini = !_state.navMini
    let open = !_state.open
    if (window.innerWidth <= 5000) {
      navMini = true;
    }
    _this.setState({ navMini, open });
  }

  hideNav = (e) => {
    const _this = this
    const _state = _this.state
    let navMini = _state.navMini
    let open = _state.open
    navMini = true;
    open = false;
    _this.setState({ navMini, open })
  }

  logout = (e) => {
    const _this = this
    const _props = _this.props
    const domainIsTenant = dit(_props);
    removeTokenDit(domainIsTenant);
    _this.setState({ logout: true });
  }

  render() {
    const _this = this
    const _props = _this.props
    const _state = _this.state
    const { logout } = _state
    if (logout) {
      return (<RedirectToLogin {..._props} />)
    }
    let navMini = _state.navMini
    let open = _state.open
    return (
      <div>
        <div className="app-wrapper">
          <TenantNav open={open} mini={navMini} toggleNav={_this.toggleNav} logout={_this.logout} header hideNav={_this.hideNav} />
          <div className={`content-container-custom ${navMini ? 'full' : ''}`}>
            {
              window.innerWidth <= 5000
                ?
                <div className='containers-iotera'>
                  {
                    !open ?
                      <TenantAppsRoutes />
                      :
                      <React.Fragment>
                        <div className='content-iotera'><TenantAppsRoutes /></div>
                        <div className='middle-iotera' onClick={() => _this.toggleNav()} />
                      </React.Fragment>
                  }
                </div>
                :
                <TenantAppsRoutes />
            }
          </div>
        </div>
        <div className={`content-container-custom ${navMini ? 'full' : ''}`}>
          <Footer />
        </div>
      </div>
    )
  }
}

export default connect()(withRouter(Main));